/**
 * Does this page look like it is being driven by a script rather than a person?
 *
 * The widget connects the chat socket and creates a guest session as soon as it
 * loads, and a guest is a "visitor" Ola greets. Headless browsers, crawlers,
 * link previewers and uptime monitors load storefronts constantly, so Ola kept
 * messaging nobody. When this is true the widget does not start at all: no
 * launcher, no session, no socket.
 *
 * Only strong signals count (the browser says it is automated, or its user agent
 * is a known tool or crawler), so a real shopper is never turned away. The
 * server applies the same user agent rule (salesive-store-api and
 * salesive-user-event-service utils/automatedClient.js), which cannot be skipped
 * by editing this file.
 *
 * Written for old WebViews: no optional chaining on browser globals, everything
 * guarded, and any error means "not automated".
 */
var AUTOMATED_UA = new RegExp(
    [
        "headless", "phantomjs", "slimerjs", "puppeteer", "playwright", "selenium",
        "webdriver", "cypress", "jsdom",
        "lighthouse", "ptst", "pagespeed", "gtmetrix", "pingdom", "uptimerobot",
        "statuscake", "site24x7", "newrelicpinger", "datadog", "betteruptime",
        "betterstack", "hetrixtools",
        "googlebot", "adsbot", "mediapartners", "google-inspectiontool", "googleother",
        "apis-google", "feedfetcher", "bingbot", "bingpreview", "msnbot", "slurp",
        "duckduckbot", "baiduspider", "yandex", "sogou", "exabot", "ia_archiver",
        "facebookexternalhit", "facebot", "slackbot", "twitterbot", "linkedinbot",
        "whatsapp/", "telegrambot", "discordbot", "pinterestbot", "applebot",
        "skypeuripreview", "embedly", "redditbot", "semrush", "ahrefs", "mj12",
        "bot[/;)]", "crawler", "spider", "scraper",
    ].join("|"),
    "i",
);

export function isAutomatedBrowser() {
    try {
        if (typeof navigator === "undefined") return false;
        // The standard flag every WebDriver based tool sets (Puppeteer,
        // Playwright, Selenium) unless the script hides it.
        if (navigator.webdriver === true) return true;
        if (AUTOMATED_UA.test(String(navigator.userAgent || ""))) return true;
        // Markers left by older tools.
        if (typeof window !== "undefined") {
            if (
                window.callPhantom ||
                window._phantom ||
                window.__nightmare ||
                window.domAutomation ||
                window.domAutomationController
            ) {
                return true;
            }
        }
        var root = typeof document !== "undefined" ? document.documentElement : null;
        if (root && root.getAttribute && root.getAttribute("webdriver")) return true;
    } catch (e) {
        /* an unreadable environment is treated as a person */
    }
    return false;
}
